import { AuthableVertical } from '../types';

export const hasRequiredVertical = (
  requiredVerticals: AuthableVertical[] | undefined,
  userVerticals: AuthableVertical[],
  isAdmin: boolean,
): boolean => isAdmin || !requiredVerticals?.length || requiredVerticals.some((v) => userVerticals.includes(v));
